import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import GuaranteeSelectionView from "./GuaranteeSelectionView";
import {CatalogService} from "../../../service/catalog/CatalogService";
import {RestrictionsService} from "../../../service/ptm/RestrictionsService";
import {EDIT_GUARANTEE_SELECTION_ROUTE, GUARANTEE_SELECTION_ROUTE} from "../../../utils/constants/RoutesConstants";

export default class GuaranteesTableContainer extends Component {
    constructor(props) {
        super(props);

        this.restrictionsService = new RestrictionsService();
        this.catalogService = new CatalogService();
        this.getDataGuaranteeSelection = this.getDataGuaranteeSelection.bind(this);

        this.state = {
            dataGuaranteeSelection: this.getDataGuaranteeSelection(),
            isLoading: true,
        };

        this.redirectEditGuaranteeSelection = this.redirectEditGuaranteeSelection.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }


    getDataGuaranteeSelection() {
        this.loading(true);
        this.restrictionsService.getRestrictions()
            .then(resp => {
                if (resp.error && resp.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: resp.error.replace(/%/g, ''),
                    });
                }
                this.setState({
                    dataGuaranteeSelection: resp.payload,
                });
                this.loading(false);
            });
    }


    redirectEditGuaranteeSelection() {
        this.props.history.push({
            pathname: EDIT_GUARANTEE_SELECTION_ROUTE,
            state: {
                returnPath: GUARANTEE_SELECTION_ROUTE,
                guaranteesSelected: this.state.dataGuaranteeSelection,
            },
        });
    }


    render() {

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        const {dataGuaranteeSelection, isLoading} = this.state;

        return <GuaranteeSelectionView dataGuaranteeSelection={dataGuaranteeSelection}
                                       isLoading={isLoading}
                                       messagesGrowl={messagesGrowl}
                                       getDataGuaranteeSelection={this.getDataGuaranteeSelection}
                                       redirectEditGuaranteeSelection={this.redirectEditGuaranteeSelection}
        />
    }
};